"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SdPlatformSdk = void 0;
const SdPlatformSdkApi_1 = require("./api/SdPlatformSdkApi");
const SdPlatformSdkConfig_1 = require("./api/SdPlatformSdkConfig");
const SdPlatformAuthServiceApi_1 = require("./auth/SdPlatformAuthServiceApi");
const SdPlatformSdkContext_1 = require("./SdPlatformSdkContext");
const SdPlatformApiTokenApi_1 = require("./resources/SdPlatformApiTokenApi");
const SdPlatformBackendSystemApi_1 = require("./resources/SdPlatformBackendSystemApi");
const SdPlatformBookmarkApi_1 = require("./resources/SdPlatformBookmarkApi");
const SdPlatformChargebeeApi_1 = require("./resources/SdPlatformChargebeeApi");
const SdPlatformDocumentApi_1 = require("./resources/SdPlatformDocumentApi");
const SdPlatformDomainApi_1 = require("./resources/SdPlatformDomainApi");
const SdPlatformHttpLogApi_1 = require("./resources/SdPlatformHttpLogApi");
const SdPlatformImageApi_1 = require("./resources/SdPlatformImageApi");
const SdPlatformModelApi_1 = require("./resources/SdPlatformModelApi");
const SdPlatformModelSharingApi_1 = require("./resources/SdPlatformModelSharingApi");
const SdPlatformModelTokenApi_1 = require("./resources/SdPlatformModelTokenApi");
const SdPlatformModelTransferApi_1 = require("./resources/SdPlatformModelTransferApi");
const SdPlatformNotificationApi_1 = require("./resources/SdPlatformNotificationApi");
const SdPlatformOrganizationApi_1 = require("./resources/SdPlatformOrganizationApi");
const SdPlatformPolicyApi_1 = require("./resources/SdPlatformPolicyApi");
const SdPlatformSavedStateApi_1 = require("./resources/SdPlatformSavedStateApi");
const SdPlatformSavedStateSharingApi_1 = require("./resources/SdPlatformSavedStateSharingApi");
const SdPlatformTagApi_1 = require("./resources/SdPlatformTagApi");
const SdPlatformUserAnalyticsApi_1 = require("./resources/SdPlatformUserAnalyticsApi");
const SdPlatformUserApi_1 = require("./resources/SdPlatformUserApi");
const SdPlatformUserCreditMetricsApi_1 = require("./resources/SdPlatformUserCreditMetricsApi");
const SdPlatformWebhookApi_1 = require("./resources/SdPlatformWebhookApi");
const SdPlatformOrganizationAnalyticsApi_1 = require("./resources/SdPlatformOrganizationAnalyticsApi");
const SdPlatformOrganizationCreditMetricsApi_1 = require("./resources/SdPlatformOrganizationCreditMetricsApi");
const SdPlatformOpenIDProviderApi_1 = require("./resources/SdPlatformOpenIDProviderApi");
const SdPlatformApiClientsApi_1 = require("./resources/SdPlatformApiClientsApi");
const SdPlatformJobLogApi_1 = require("./resources/SdPlatformJobLogApi");
const SdPlatformStargateApi_1 = require("./resources/SdPlatformStargateApi");
class SdPlatformSdk {
    /**
     * ShapeDiverSDK constructor
     * @param clientId - the client id
     * @param clientSecret - the client secret
     * @param baseUrl - the base url
     */
    constructor(clientId, clientSecret, baseUrl) {
        this.__config = new SdPlatformSdkConfig_1.SdPlatformSdkConfig(clientId, clientSecret, baseUrl);
        this.__api = new SdPlatformSdkApi_1.SdPlatformSdkApi(this.__config);
        const context = new SdPlatformSdkContext_1.SdPlatformSdkContext(this.__api, this.__config);
        this.__authorization = new SdPlatformAuthServiceApi_1.SdPlatformAuthServiceApi(context);
        this.__apiClients = new SdPlatformApiClientsApi_1.SdPlatformApiClientsApi(context, this.__authorization);
        this.__api_tokens = new SdPlatformApiTokenApi_1.SdPlatformApiTokenApi(context, this.__authorization);
        this.__backendSystem = new SdPlatformBackendSystemApi_1.SdPlatformBackendSystemApi(context, this.__authorization);
        this.__bookmarks = new SdPlatformBookmarkApi_1.SdPlatformBookmarkApi(context, this.__authorization);
        this.__chargebee = new SdPlatformChargebeeApi_1.SdPlatformChargebeeApi(context, this.__authorization);
        this.__domains = new SdPlatformDomainApi_1.SdPlatformDomainApi(context, this.__authorization);
        this.__documents = new SdPlatformDocumentApi_1.SdPlatformDocumentApi(context, this.__authorization);
        this.__http_logs = new SdPlatformHttpLogApi_1.SdPlatformHttpLogApi(context, this.__authorization);
        this.__jobLogs = new SdPlatformJobLogApi_1.SdPlatformJobLogApi(context, this.__authorization);
        this.__images = new SdPlatformImageApi_1.SdPlatformImageApi(context, this.__authorization);
        this.__model_sharing = new SdPlatformModelSharingApi_1.SdPlatformModelSharingApi(context, this.__authorization);
        this.__models = new SdPlatformModelApi_1.SdPlatformModelApi(context, this.__authorization);
        this.__modelTokens = new SdPlatformModelTokenApi_1.SdPlatformModelTokenApi(context, this.__authorization);
        this.__modelTransfers = new SdPlatformModelTransferApi_1.SdPlatformModelTransferApi(context, this.__authorization);
        this.__notifications = new SdPlatformNotificationApi_1.SdPlatformNotificationApi(context, this.__authorization);
        this.__openidProviders = new SdPlatformOpenIDProviderApi_1.SdPlatformOpenIDProviderApi(context, this.__authorization);
        this.__organizations = new SdPlatformOrganizationApi_1.SdPlatformOrganizationApi(context, this.__authorization);
        this.__organizationCreditMetrics = new SdPlatformOrganizationCreditMetricsApi_1.SdPlatformOrganizationCreditMetricsApi(context, this.__authorization);
        this.__policies = new SdPlatformPolicyApi_1.SdPlatformPolicyApi(context, this.__authorization);
        this.__savedStates = new SdPlatformSavedStateApi_1.SdPlatformSavedStateApi(context, this.__authorization);
        this.__savedStateSharing = new SdPlatformSavedStateSharingApi_1.SdPlatformSavedStateSharingApi(context, this.__authorization);
        this.__tags = new SdPlatformTagApi_1.SdPlatformTagApi(context, this.__authorization);
        this.__userAnalytics = new SdPlatformUserAnalyticsApi_1.SdPlatformUserAnalyticsApi(context, this.__authorization);
        this.__organizationAnalytics = new SdPlatformOrganizationAnalyticsApi_1.SdPlatformOrganizationAnalyticsApi(context, this.__authorization);
        this.__users = new SdPlatformUserApi_1.SdPlatformUserApi(context, this.__authorization);
        this.__userCreditMetrics = new SdPlatformUserCreditMetricsApi_1.SdPlatformUserCreditMetricsApi(context, this.__authorization);
        this.__webhooks = new SdPlatformWebhookApi_1.SdPlatformWebhookApi(context);
        this.__stargate = new SdPlatformStargateApi_1.SdPlatformStargateApi(context, this.__authorization);
    }
    /**
     * Configuration for this instance of the Platform SDK.
     */
    get config() {
        return this.__config;
    }
    /**
     * Authentication service for ShapeDiver Platform.
     */
    get authorization() {
        return this.__authorization;
    }
    /**
     * CRUD operations for Platform API clients.
     */
    get apiClients() {
        return this.__apiClients;
    }
    /**
     * CRUD operations for Platform API tokens.
     * Platform API tokens can be limited in scope and lifetime.
     * Use Platform API tokens for applications making use of the Platform API.
     * Limit their scope as much as possible.
     */
    get apiTokens() {
        return this.__api_tokens;
    }
    /**
     * Operations for ShapeDiver Geometry Backend Systems known by the Platform Backend.
     */
    get backendSystem() {
        return this.__backendSystem;
    }
    /**
     * Operations for creating and deleting bookmarks
     */
    get bookmarks() {
        return this.__bookmarks;
    }
    /**
     * Actions related to Chargebee subscription management.
     */
    get chargebee() {
        return this.__chargebee;
    }
    /**
     * The documents api actions.
     */
    get documents() {
        return this.__documents;
    }
    /**
     * Operations for domains which can be attached to users, organizations, models.
     */
    get domains() {
        return this.__domains;
    }
    /**
     * HTTP logs.
     */
    get httpLogs() {
        return this.__http_logs;
    }
    /**
     * Operations for job logs.
     */
    get jobLogs() {
        return this.__jobLogs;
    }
    /**
     * Operations for images which can be attached to models
     */
    get images() {
        return this.__images;
    }
    /**
     * Operations for model sharing relationships.
     */
    get modelSharing() {
        return this.__model_sharing;
    }
    /**
     * Operations for models on the ShapeDiver Platform.
     */
    get models() {
        return this.__models;
    }
    /**
     * Operations for creating tokens for models on Geometry Backend Systems
     */
    get modelTokens() {
        return this.__modelTokens;
    }
    /**
     * Operations for creating, revoking, accepting, denying, model ownership transfer notifications.
     */
    get modelTransfers() {
        return this.__modelTransfers;
    }
    /**
     * Operations for querying, reading/unreading, creating notifications.
     */
    get notifications() {
        return this.__notifications;
    }
    /**
     * Gets the openid providers.
     */
    get openidProviders() {
        return this.__openidProviders;
    }
    /**
     * Operations for organizations.
     */
    get organizations() {
        return this.__organizations;
    }
    /**
     * Operations for policies.
     */
    get policies() {
        return this.__policies;
    }
    /**
     * Operations for saved states.
     */
    get savedStates() {
        return this.__savedStates;
    }
    /**
     * Operations related to stargate api.
     */
    get stargate() {
        return this.__stargate;
    }
    /**
     * Operations for saved state sharing relationships.
     */
    get savedStateSharing() {
        return this.__savedStateSharing;
    }
    /**
     * Operations for tags which can be attached to models.
     */
    get tags() {
        return this.__tags;
    }
    /**
     * Analytics for users.
     */
    get userAnalytics() {
        return this.__userAnalytics;
    }
    /**
     * Analytics for organizations.
     */
    get organizationAnalytics() {
        return this.__organizationAnalytics;
    }
    /**
     * Operations for organization credit metrics.
     */
    get organizationCreditMetrics() {
        return this.__organizationCreditMetrics;
    }
    /**
     * Operations for users.
     */
    get users() {
        return this.__users;
    }
    /**
     * Operations for user credit metrics.
     */
    get userCreditMetrics() {
        return this.__userCreditMetrics;
    }
    /**
     * Webhook calls.
     */
    get webhooks() {
        return this.__webhooks;
    }
    /**
     * Register callbacks for request start events.
     * onRequestStart is fired before each request. This does not modify request, it is used only as notification that request is starting.
     * NOTE: requestParams is as shallow copy.
     * @param cb
     */
    onRequestStart(cb) {
        this.__api.onRequestStart(cb);
    }
    /**
     * Register callbacks for request finished events.
     * onRequestFinished is fired after request has been resolved.
     * NOTE: response is passed as shallow copy.
     * NOTE: requestParams is as shallow copy.
     * @param cb
     */
    onRequestFinished(cb) {
        this.__api.onRequestFinished(cb);
    }
}
exports.SdPlatformSdk = SdPlatformSdk;
//# sourceMappingURL=SdPlatformSdk.js.map